/* unplugin-vue-components disabled */import { render } from "./track-company.vue?vue&type=template&id=4e23df9a&scoped=true"
import script from "./track-company.vue?vue&type=script&lang=js"
export * from "./track-company.vue?vue&type=script&lang=js"

import "./track-company.vue?vue&type=style&index=0&id=4e23df9a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e23df9a"],['__file',"src/pages/pulse/tracker/track-company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e23df9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e23df9a', __exports__)) {
    api.reload('4e23df9a', __exports__)
  }
  
  module.hot.accept("./track-company.vue?vue&type=template&id=4e23df9a&scoped=true", () => {
    api.rerender('4e23df9a', render)
  })

}


export default __exports__